import {
  CHECKOUT_RESET_TO_DEFAULT_STATE,
  CHECKOUT_SET_GIFT_MESSAGE,
  CHECKOUT_SET_GIFT_OPTIONS,
  CHECKOUT_SET_GIFT_OPTIONS_LOADING,
  CHECKOUT_SET_GIFT_OPTIONS_STATE,
  CHECKOUT_SET_USE_GIFT_BAG,
  CHECKOUT_SET_USE_GIFT_RECEIPT
} from 'constants/reduxActions';

const defaultState = {
  isLoaded: false,
  isLoading: false,
  giftMessage: '',
  giftOptions: {},
  lineItemId: null,
  useGiftBag: false,
  useGiftReceipt: true
};

export function giftOptions(state = defaultState, action = {}) {
  const { giftMessage = '', giftOptions, isLoading, lineItemId, type, useGiftBag, useGiftReceipt } = action;

  switch (type) {
    case CHECKOUT_SET_USE_GIFT_RECEIPT: {
      return { ...state, useGiftReceipt };
    }

    case CHECKOUT_SET_GIFT_OPTIONS_STATE: {
      const newState = {
        ...state,
        giftMessage,
        useGiftReceipt,
        useGiftBag,
        lineItemId
      };
      return addValidationMessages(newState);
    }

    case CHECKOUT_SET_GIFT_MESSAGE: {
      const newState = { ...state, giftMessage };
      return addValidationMessages(newState);
    }

    case CHECKOUT_SET_USE_GIFT_BAG: {
      return { ...state, useGiftBag };
    }

    case CHECKOUT_SET_GIFT_OPTIONS: {
      return { ...state, giftOptions };
    }

    case CHECKOUT_SET_GIFT_OPTIONS_LOADING: {
      if (!isLoading) {
        return { ...state, isLoading, isLoaded: true };
      }
      return { ...state, isLoading };
    }

    case CHECKOUT_RESET_TO_DEFAULT_STATE: {
      return defaultState;
    }

    default:
      return state;
  }
}

export function addValidationMessages(state) {
  const { giftMessage, giftOptions: { giftOptions }, lineItemId } = state;

  if (!lineItemId) {
    return state;
  }

  const giftOption = giftOptions[lineItemId];
  const { giftMessage: { maxLines, maxTotalLength } } = giftOption;

  // Count the number of lines
  const numLines = giftMessage.split('\n').length;
  const size = giftMessage.length;

  // Determine the differences
  const charDelta = maxTotalLength - size;
  let lineDelta = maxLines - numLines;

  // Adjusting the line count according to entered text (24 characters = 1 line)
  const tempMsg = giftMessage.split('\n');
  tempMsg.forEach(eachLine => {
    if (eachLine.length > 24) {
      if ((eachLine.length % 24) === 0) {
        lineDelta -= Math.floor(eachLine.length / 24) - 1;
      } else {
        lineDelta -= Math.floor(eachLine.length / 24);
      }
    }
  });

  let charMessage = '';
  let lineMessage = '';
  let charMessageWarning = false;
  let lineMessageWarning = false;

  switch (true) {
    case charDelta < -1:
      charMessage = `${Math.abs(charDelta)} characters over`;
      charMessageWarning = true;
      break;
    case charDelta < 0:
      charMessage = '1 character over';
      charMessageWarning = true;
      break;
    case charDelta === 1:
      charMessage = '1 character';
      break;
    default:
      charMessage = `${charDelta} characters`;
  }

  switch (true) {
    case lineDelta < -1:
      lineMessage = `${Math.abs(lineDelta)} lines over`;
      lineMessageWarning = true;
      break;
    case lineDelta < 0:
      lineMessage = '1 line over';
      lineMessageWarning = true;
      break;
    case lineDelta === 1:
      lineMessage = '1 line';
      break;
    default:
      lineMessage = `${lineDelta} lines`;
  }

  return { ...state, lineMessage, lineMessageWarning, charMessage, charMessageWarning };
}
